const baseProps = {
    width: 20,
    height: 20,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true
};

export function SettingsIcon({ size = 22, style }) {
    return (
        <svg {...baseProps} width={size} height={size} style={style}>
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.01a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h.01a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.01a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
    );
}

export function UsersIcon({ size = 22, style }) {
    return (
        <svg {...baseProps} width={size} height={size} style={style}>
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="8.5" cy="7" r="3" />
            <path d="M20 8v6" />
            <path d="M23 11h-6" />
        </svg>
    );
}

export function ChatIcon({ size = 22, style }) {
    return (
        <svg {...baseProps} width={size} height={size} style={style}>
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z" />
        </svg>
    );
}

export function MicIcon({ size = 22, style }) {
    return (
        <svg {...baseProps} width={size} height={size} style={style}>
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
            <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
            <line x1="12" y1="19" x2="12" y2="23" />
            <line x1="8" y1="23" x2="16" y2="23" />
        </svg>
    );
}

export function MoonIcon({ size = 20, style }) {
    return (
        <svg {...baseProps} width={size} height={size} style={style}>
            <path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z" />
        </svg>
    );
}

export function SunIcon({ size = 20, style }) {
    return (
        <svg {...baseProps} width={size} height={size} style={style}>
            <circle cx="12" cy="12" r="4" />
            <line x1="12" y1="2" x2="12" y2="4" />
            <line x1="12" y1="20" x2="12" y2="22" />
            <line x1="4.93" y1="4.93" x2="6.34" y2="6.34" />
            <line x1="17.66" y1="17.66" x2="19.07" y2="19.07" />
            <line x1="2" y1="12" x2="4" y2="12" />
            <line x1="20" y1="12" x2="22" y2="12" />
            <line x1="4.93" y1="19.07" x2="6.34" y2="17.66" />
            <line x1="17.66" y1="6.34" x2="19.07" y2="4.93" />
        </svg>
    );
}

export function ShuffleIcon({ size = 20, style }) {
    return (
        <svg {...baseProps} width={size} height={size} style={style}>
            <path d="M17 2h5v5" />
            <path d="M3 7h5l9 10h5" />
            <path d="M22 17v5h-5" />
            <path d="M3 17h5l2-2" />
            <path d="M14 6l3-3h5" />
        </svg>
    );
}

export function SkullIcon({ size = 20, style }) {
    return (
        <svg {...baseProps} width={size} height={size} style={style}>
            <path d="M12 2C7.58 2 4 5.58 4 10c0 2.58 1.22 4.88 3.11 6.34L7 20h10l-.11-3.66A7.96 7.96 0 0 0 20 10c0-4.42-3.58-8-8-8z" />
            <circle cx="9" cy="10" r="1.3" fill="currentColor" stroke="none" />
            <circle cx="15" cy="10" r="1.3" fill="currentColor" stroke="none" />
            <path d="M10 15h4" />
            <path d="M10 18v2" />
            <path d="M14 18v2" />
        </svg>
    );
}

export function HeartPulseIcon({ size = 20, style }) {
    return (
        <svg {...baseProps} width={size} height={size} style={style}>
            <path d="M20.8 8.5c0 5.2-8.8 11.2-8.8 11.2S3.2 13.7 3.2 8.5A5.2 5.2 0 0 1 12 5a5.2 5.2 0 0 1 8.8 3.5z" />
            <path d="M7 11h3l1.5-2 2 4 1.5-2H17" />
        </svg>
    );
}

export function SearchIcon({ size = 20, style }) {
    return (
        <svg {...baseProps} width={size} height={size} style={style}>
            <circle cx="11" cy="11" r="7" />
            <line x1="16.65" y1="16.65" x2="21" y2="21" />
        </svg>
    );
}
